<template>
  <div class="account-box">
    <div class="wrp-box">
      <div class="act-box">
        <div class="cr-box">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span class="card-title">{{ $t("avatarSelect.AccountInformation") }}</span>
            </div>
            <div>
              <div style="width: 420px; margin: 0 auto">
                <el-row :gutter="20">
                  <el-col :span="10">
                    <div class="item-t">
                      {{ $t("avatarSelect.Email") }}
                    </div>
                    <div class="item-t">
                      {{ $t("avatarSelect.CreatedTime") }}
                    </div>
                    <div class="item-t">
                      {{ $t("avatarSelect.AccountStatus") }}
                    </div>
                    <!-- <div class="item-t">
                      {{ $t('avatarSelect.WxBind') }}
                    </div> -->
                  </el-col>
                  <el-col :span="12">
                    <div class="item-v">{{ act_info.user_name }}</div>
                    <div class="item-v">{{ act_info.create_time }}</div>
                    <div
                      class="item-v"
                      :style="
                        act_info.status == 'Active'
                          ? 'color: #64BCA2'
                          : 'color: red'
                      "
                    >
                      {{ act_info.status }}
                    </div>
                    <!-- <div class="item-v" style="display: flex">
                        <button v-if="visiBind" @click="toWechatBind" style="width:98px;" class="cur hv" type="button">{{ $t('avatarSelect.ToBind') }}</button>
                        <span v-if="visiBund" class="et bound">{{ $t('avatarSelect.Bound') }}</span>
                        <button v-if="visiBund" @click="unBind" style="width:98px;margin-left:10px" class="cur hv" type="button">{{ $t('avatarSelect.Unbind') }}</button>
                    </div> -->
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-card>
        </div>
      </div>

      <div class="address-wp">
        <div class="cr-box">
          <el-card class="box-card">
            <div slot="header" class="clearfix" style="display:flex;align-items:center;justify-content:space-between;">
              <span style="flex:1;" class="card-title">{{ $t("WithdrawUSDT.WithdrawAddress") }}</span>
              <el-button
                @click="openAddAddressDialog"
                type="success"
                >{{ $t("WithdrawUSDT.AddBtn") }}</el-button
              >
            </div>
            <AddressTable :allAddressData="allAddressData" :addressTableLoading="addressTableLoading" :isUseSelect="false" @emitDeleted="clickDeleted" @emitInitListData="initAllAddressApi"></AddressTable>
          </el-card>
        </div>
      </div>

      <div class="security-box">
        <div class="cr-box">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span class="card-title">{{ $t("avatarSelect.Security") }}</span>
            </div>
            <div>
              <div class="scry-item">
                <div>
                  <div style="padding-bottom: 0.5rem">{{ $t("avatarSelect.ResetPassword") }}</div>
                  <div>{{ $t("avatarSelect.ResetPasswordTip") }}</div>
                </div>
                <div>
                  <!-- <el-button @click="toResetpwd" style="background: #00bea4; color: #fff"
                    >{{ $t("avatarSelect.ResetPassword") }}</el-button
                  > -->
                  <button @click="toResetpwd" style="" class="cur hv" type="button">{{ $t("avatarSelect.ResetPassword") }}</button>
                </div>
              </div>
              <div class="scry-item" style="border: 0">
                <div>
                  <div style="padding-bottom: 0.5rem">{{ $t("avatarSelect.TwoFactorAuthentication") }}</div>
                  <div>{{ $t("avatarSelect.TwoFactorTip") }}</div>
                </div>
                <div>
                  <el-switch
                    v-model="value"
                    active-color="#00bea4"
                    active-value="1"
                    inactive-value="0"
                    @change="switchVal"
                  >
                  </el-switch>
                </div>
              </div>
              <div style="padding:16px;font-size:14px;background:#F5F6F7;font-family:AxLLCircular, Helvetica, Arialsans-serif">
                <el-row style="padding-bottom:10px;border-bottom:1px solid #eee">
                  <el-col :span="6">
                    <div class="col-it">{{ $t("avatarSelect.authenticationMethodEmail") }}<span class="et">{{ $t("avatarSelect.Method") }}</span></div>
                  </el-col>
                  <el-col :span="12">
                    <div class="col-it">{{ $t("avatarSelect.authenticationMethodEmailTip") }}</div>
                  </el-col>
                  <el-col :span="6"></el-col>
                </el-row>

                <!-- Google -->
                <el-row style="padding-bottom:10px;padding-top:10px;border-bottom:1px solid #eee">
                  <el-col :span="6">
                    <div class="col-it">{{ $t("LoginFields.UserAuthenticator") }}</div>
                  </el-col>
                  <el-col :span="12">
                    <div class="col-it">{{ $t("LoginFields.UserAuthenticatorCenterTip") }}</div>
                  </el-col>
                  <el-col :span="6">
	                    <div class="col-it">
	                      <div style="text-align:right">
	                        <button :disabled="google_checking_status()" @click="bindGoogleCode" style="padding:2px 6px" class="cur hv" type="button">{{google_checking_status() ? $t("LoginFields.UserGoogleCheckingStatus1") : $t("LoginFields.UserGoogleCheckingStatus0") }}</button>
		                        <button
		                          v-if="google_checking_status()"
		                          @click="openReplaceGoogleDialog"
		                          class="google-rebind-btn"
		                          type="button"
		                        >
	                          {{ googleRebindText }}
	                        </button>
	                      </div>
	                    </div>
	                  </el-col>
                </el-row>

                <el-row style="padding-top:10px;">
                  <el-col :span="6">
                    <div class="col-it">{{ $t("avatarSelect.RecoveryCodes") }}</div>
                  </el-col>
                  <el-col :span="12">
                    <div class="col-it">{{ $t("avatarSelect.CenterDesc") }}</div>
                  </el-col>
                  <el-col :span="6">
                    <div class="col-it">
                      <div style="text-align:right">
                        <button @click="tqVerify" style="padding:2px 6px" class="cur hv" type="button">{{ $t("avatarSelect.Generate") }}</button>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
              
              <!-- <div class="box-item">
                <div class="bit" style="padding-left:10px">
                  <div class="col-it" style="padding-bottom:0.5rem">{{ $t("avatarSelect.authenticationMethodEmail") }}<span class="et">{{ $t("avatarSelect.Method") }}</span></div>
                  <div class="col-it" style="padding-bottom:0.5rem">{{ $t("LoginFields.UserAuthenticator") }}</div>
                  <div class="col-it">{{ $t("avatarSelect.RecoveryCodes") }}</div>
                </div>
                <div class="bit" style="margin-left:auto">
                  <div class="col-it" style="padding-bottom:0.5rem">{{ $t("avatarSelect.authenticationMethodEmailTip") }}</div>
                  <div class="col-it" style="padding-bottom:0.5rem">{{ $t("LoginFields.UserAuthenticatorCenterTip") }}</div>
                  <div class="col-it">{{ $t("avatarSelect.CenterDesc") }}</div>
                </div>
                <div class="bit" style="margin-left:auto">
                  <div class="col-it" style="padding-bottom:0.5rem">
                    <div style="opacity:0;text-align:right">
                      <button style="padding:0 6px" class="cur hv" type="button">生成備用碼</button>
                    </div>
                  </div>
                  <div class="col-it">
                    <div style="text-align:right">
                      <button @click="tqVerify" style="padding:2px 6px" class="cur hv" type="button">{{ $t("avatarSelect.Generate") }}</button>
                    </div>
                  </div>
                </div>
              </div> -->
              <!-- <div class="acitem" style="border: 0">
                <el-row :gutter="20" type="flex">
                <el-col :xs="20" :sm="16" :md="10" :lg="10" :xl="6"><div class="col-it">{{ $t("avatarSelect.authenticationMethodEmail") }}<span class="et">{{ $t("avatarSelect.Method") }}</span></div></el-col>
                <el-col :span="12"><div class="col-it">{{ $t("avatarSelect.authenticationMethodEmailTip") }}</div></el-col>
                <el-col :span="6">
                  <div class="col-it">
                    <div style="opacity:0;text-align:right">
                      <button style="padding:0 6px" class="cur hv" type="button">生成備用碼</button>
                    </div>
                  </div>
                </el-col>
              </el-row>
              </div> -->
              <!-- <div class="acitem" style="border: 0">
                <el-row :gutter="20" type="flex">
                <el-col :span="6"><div class="col-it">{{ $t("avatarSelect.RecoveryCodes") }}</div></el-col>
                <el-col :span="12"><div class="col-it">{{ $t("avatarSelect.CenterDesc") }}</div></el-col>
                <el-col :span="6">
                  <div class="col-it">
                    <div style="text-align:right">
                      <button @click="tqVerify" style="padding:0 6px" class="cur hv" type="button">{{ $t("avatarSelect.Generate") }}</button>
                    </div>
                  </div>
                </el-col>
              </el-row>
              </div> -->
              <!-- <div class="box-item">
                <div class="acitem" style="border: 0">
                <div class="nitem" style="justify-content:space-between;">
                  <div>{{ $t("avatarSelect.authenticationMethodEmail") }}
                    <span class="et">{{ $t("avatarSelect.Method") }}</span>
                    
                  </div>
                  <div style="">
                    <span>{{ $t("avatarSelect.authenticationMethodEmailTip") }}</span>
                  </div>
                  <div style="opacity:0">
                    <button style="padding:0 6px" class="cur hv" type="button">生成備用碼</button>
                  </div>
                </div>
                
              </div>
              <div class="acitem" style="border: 0;">
              <div class="nitem" style="justify-content:space-between;">
                  <div style="">{{ $t("avatarSelect.RecoveryCodes") }}</div>
                  <div style="">
                    <span>{{ $t("avatarSelect.CenterDesc") }}</span>
                  </div>
                  <div>
                    <button @click="tqVerify" style="padding:0 6px" class="cur hv" type="button">{{ $t("avatarSelect.Generate") }}</button>
                  </div>
                </div>
              </div>
              </div> -->
            </div>
          </el-card>
        </div>
      </div>

      <!-- <div class="fund-box">
        <div class="cr-box" style="padding-bottom: 2rem;">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span class="card-title">{{ $t("avatarSelect.FundAccountInformation") }}</span>
            </div>
            <div>
              <div style="width: 420px; margin: 0 auto">
                <div v-if="isNone">
                  <button @click="toAddFund" style="width:126px;" class="cur hv" type="button">{{ $t("avatarSelect.AddFundAccount") }}</button>
                </div>
                <el-row :gutter="20" v-else>
                  <el-col :span="10">
                    <div class="item-t" style="display:flex;align-items:center">
                      {{ $t("avatarSelect.AccountName") }}
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="$t('Funds.Accounts.AccountNameTips')"
                        placement="right-start"
                      >
                        <i class="el-icon-warning" style="color: #e6a23c;padding:0;margin-left:.3rem"></i>
                      </el-tooltip>
                    </div>
                    <div class="item-t">
                      {{ $t("avatarSelect.AccountNumber") }}
                    </div>
                    <div class="item-t">
                      {{ $t("avatarSelect.BankName") }}
                    </div>
                    <div class="item-t">
                      {{ $t("avatarSelect.Status") }}
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="item-v">{{ fund_info.account_name }}</div>
                    <div class="item-v">{{ fund_info.account_number }}</div>
                    <div class="item-v">{{ fund_info.bank_name }}</div>
                    <div
                      class="item-v"
                      :style="`color: ${getStatus(fund_info.status)}`"
                    >
                      {{ fund_info.status }}
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-card>
        </div>
      </div> -->
    </div>
    <!-- 驗證身份彈窗 -->
    <div>
      <el-dialog
        :close-on-click-modal="false"
        :visible.sync="verifyVisible"
        width="30%">
        <div slot="title" class="digTitle">
            <div>{{ $t("avatarSelect.VerifyItsYou") }}</div>
          </div>
        <div>
          
          <div>
            <el-alert :title="$t('avatarSelect.VerifyItsYouTopTip')" type="info" show-icon></el-alert>
          </div>
          <div class="sent-tip">
            <span style="font-size:13px">{{ $t("avatarSelect.VerifyItsYouTopTip2") }}</span>
          </div>
          <div class="verify-code-box">
            <label>{{ $t("avatarSelect.VerifyCode") }}</label>
            <el-input v-model="code6" placeholder="Code"></el-input>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="jx-btn" @click="jxHandler">{{ $t("avatarSelect.Continue") }}</el-button>
          <!-- <el-button type="primary" @click="dialogVisible = false">确 定</el-button> -->
        </span>
      </el-dialog>
    </div>
    <!-- 查看備用碼 -->
    <div>
      <el-dialog
        :close-on-click-modal="false"
        :visible.sync="ckVerifyVisible"
        :show-close="false"
        width="30%">
          <div slot="title" class="">
              <div class="title-ck-box">
                <div class="digTitle" style="font-size:18px">{{ $t("avatarSelect.RecoveryCodes") }}</div>
                <div class="ck-btn-box">
                  <el-button @click="clickCopy" class="jx-btn" size="small" style="background:#00BEA4;color:#fff">{{ $t("avatarSelect.CopyBtn") }}</el-button>
                  <!-- <el-button class="jx-btn" style="background:#00BEA4;color:#fff" size="small">下載</el-button> -->
                </div>
              </div>
              <div class="title-ck-tip">
                <span style="font-size:13px">{{ $t("avatarSelect.LookCodeTip") }}</span>
              </div>
          </div>
        <div>
          <div class="code-ck-box" id="colContent">
            <el-row :gutter="20">
              <el-col :span="12" v-for="(item,index) in codeArr" :key="index"><div class="grid-content bg-purple">{{item}}</div></el-col>
              <!-- <el-col :span="12"><div class="grid-content bg-purple">33333333</div></el-col>
              <el-col :span="12"><div class="grid-content bg-purple">57798808</div></el-col>

              <el-col :span="12"><div class="grid-content bg-purple">23143545</div></el-col>

              <el-col :span="12"><div class="grid-content bg-purple">12446576</div></el-col>

              <el-col :span="12"><div class="grid-content bg-purple">11111111</div></el-col>

              <el-col :span="12"><div class="grid-content bg-purple">32423543</div></el-col> -->

            </el-row>
          </div>
          <div style="padding-top:20px">
            <el-alert :title="$t('avatarSelect.LookCodeTip2')" type="info" show-icon></el-alert>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="jx-btn" @click="gbHandler">{{ $t("avatarSelect.CloseBtn") }}</el-button>
          <!-- <el-button type="primary" @click="dialogVisible = false">确 定</el-button> -->
        </span>
      </el-dialog>
    </div>
    <!-- Google绑定窗口 -->
    <div>
      <el-dialog
        :close-on-click-modal="false"
        @close="closeGoogleBind"
        :visible.sync="googleDialogState"
        width="35%">
        <div v-if="smCont">
          <div>
            <el-alert
              title=""
              type="info"
              :closable="false"
              show-icon
              :description="$t('LoginFields.UserBindAuthTip0')">
            </el-alert>
          </div>
          <div style="display:flex;align-items:center">
            <vueQr
              :text="erCode"
              :size="size"
              :logoScale="logoScale"
            ></vueQr>
            <div>
              <div style="font-weight:bold;">{{$t('LoginFields.UserBindAuthTip0_0')}}</div>
              <div style="color:#00BEA4;margin-top:10px;font-weight:bold;">{{screnCode}} <i class="el-icon-document-copy" @click="copyToClipboard(screnCode)" style="font-size:18px;cursor:pointer;"></i></div>
            </div>
          </div>
        </div>
        <div v-else>
          <el-alert
              title=""
              type="info"
              :closable="false"
              :description="$t('LoginFields.UserBindNextTip')">
            </el-alert>
          <div>
            <span style="display:block;margin:5px 0;">{{$t('LoginFields.UserGoogleAuthCodeLabel')}}</span>
            <CInput v-model="googleCode" :placeholder="$t('LoginFields.UserGoogleAuthInputPlacholder')"></CInput>
          </div>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button @click="goBack" v-if="!smCont">{{$t('LoginFields.UserGoogleAuthToBackLabel')}}</el-button>
          <el-button :loading="loadingGoogle" @click="completeBindGoogle" style="background:#00BEA4;color:#ffffff;" v-if="!smCont">{{$t('LoginFields.UserGoogleAuthConfirm')}}</el-button>
          <el-button v-else style="background:#00BEA4;color:#ffffff;" @click="googleBindNext">{{$t('LoginFields.NextStep')}}</el-button>
        </div>

	      </el-dialog>
	    </div>
	    <!-- 重新綁定 Google 驗證器窗口：此流程使用新服務接口，不影響第一次綁定的舊服務窗口。 -->
	    <div>
	      <el-dialog
	        :close-on-click-modal="false"
	        :visible.sync="replaceGoogleDialogVisible"
	        width="35%"
	        @close="closeReplaceGoogleDialog"
	      >
	        <div slot="title">{{ replaceGoogleTitle }}</div>

	        <!-- 第一步：發送並驗證郵箱驗證碼，驗證成功後才能進入 QRCode 綁定步驟。 -->
	        <div v-if="replaceGoogleStep === 1" class="replace-google-step">
	          <el-alert
	            :title="replaceEmailTip"
	            type="info"
	            :closable="false"
	            show-icon
	          ></el-alert>
	          <div class="replace-google-field">
	            <span class="replace-google-label">{{ replaceEmailCodeLabel }}</span>
	            <div class="replace-email-row">
	              <CInput
	                v-model="replaceEmailCode"
	                :placeholder="replaceEmailCodePlaceholder"
	                autocomplete="one-time-code"
	              ></CInput>
		              <el-button
		                :loading="replaceSendingCode"
		                :disabled="replaceCodeCountdown > 0"
		                class="replace-google-primary-btn"
		                @click="sendReplaceGoogleEmailCode"
		              >
	                {{ replaceSendCodeText }}
	              </el-button>
	            </div>
	          </div>
	        </div>

	        <!-- 第二步：展示新服務返回的 QRCode/密鑰，使用者掃碼後輸入驗證器 6 位碼完成激活。 -->
	        <div v-else class="replace-google-step">
	          <el-alert
	            :title="replaceGoogleSetupTip"
	            type="info"
	            :closable="false"
	            show-icon
	          ></el-alert>
	          <div class="replace-google-qr-row">
	            <vueQr
	              v-if="replaceQrText"
	              :text="replaceQrText"
	              :size="size"
	              :logoScale="logoScale"
	            ></vueQr>
	            <div class="replace-google-secret">
	              <div class="replace-google-label">{{ replaceSecretLabel }}</div>
	              <div class="replace-google-secret-value">
	                {{ replaceSecret || '-' }}
	                <i
	                  v-if="replaceSecret"
	                  class="el-icon-document-copy"
	                  @click="copyToClipboard(replaceSecret)"
	                ></i>
	              </div>
	            </div>
	          </div>
	          <div class="replace-google-field">
	            <span class="replace-google-label">{{ replaceGoogleCodeLabel }}</span>
	            <CInput
	              v-model="replaceGoogleCode"
	              :placeholder="replaceGoogleCodePlaceholder"
	              autocomplete="one-time-code"
	            ></CInput>
	          </div>
	        </div>

	        <div slot="footer" class="dialog-footer">
	          <el-button @click="replaceGoogleDialogVisible = false">{{ replaceCancelText }}</el-button>
	          <el-button
	            v-if="replaceGoogleStep === 1"
	            :loading="replaceVerifyingEmail || replaceSettingUp"
	            class="replace-google-primary-btn"
	            @click="verifyReplaceGoogleEmailCode"
	          >
	            {{ replaceNextText }}
	          </el-button>
	          <el-button
	            v-else
	            :loading="replaceConfirming"
	            class="replace-google-primary-btn"
	            @click="confirmReplaceGoogleBind"
	          >
	            {{ replaceConfirmText }}
	          </el-button>
	        </div>
	      </el-dialog>
	    </div>
	    <div>
	      <!-- 新增地址窗口 -->
	      <el-dialog
        width="50%"
        custom-class="brd"
        :close-on-click-modal="false"
        :title="$t('WithdrawUSDT.AddDialogTitle')"
        :visible.sync="dialogAddAddressVisible"
        @close="closeAddDialog"
      >
        <div class="addaddress-box">
          <div v-if="step1" class="step1-box">
            <div style="margin-bottom: 20px">
              <div style="margin-bottom: 8px">
                <sup style="color:red;margin-right: 5px;font-size: 14px;vertical-align: bottom;">*</sup>{{ $t("WithdrawUSDT.NewTronAddress") }}
              </div>
              <CInput
                v-model="ruleForm.address"
                oninput="value=value.replace(/[^a-zA-Z0-9]/g, '')"
                type="text"
                :invalid-feedback="errorBackAddress"
                :is-valid="validatorAddress"
                valid-feedback=""
              />
              <!-- <div class="invalid-feedback">{{ errorBackAddress }}</div> -->
            </div>
            <div style="margin-bottom: 20px">
              <div style="margin-bottom: 8px">
                <sup style="color:red;margin-right: 5px;font-size: 14px;vertical-align: bottom;">*</sup>{{ $t("WithdrawUSDT.ListTag") }}
              </div>
              <CInput
                v-model="ruleForm.tag"
                type="text"
                :invalid-feedback="errorBackTag"
                :is-valid="validatorTag"
                valid-feedback=""
                style="margin-bottom:5px"
              />
              <div v-show="visiTagMessage" style="color:#e55353;font-size:80%;">{{ tagErrorMessage }}</div>
            </div>
            <div>
              <el-tabs v-model="activeNameResetPwd" @tab-click="handleCommand">
                <el-tab-pane :label="$t('LoginFields.UserEmailRecover')" name="em">
                  <div style="margin-bottom: 20px">
                    <div style="margin-bottom: 8px">
                      <sup
                        style="
                          color: red;
                          margin-right: 5px;
                          font-size: 14px;
                          vertical-align: bottom;
                        "
                        >*</sup
                      >{{ $t("avatarSelect.EmailCode") }}
                    </div>
                    <div class="fl" style="padding:5px">
                        <div style="width:100%">
                          <CInput style="margin-bottom:5px;" autocomplete="username" v-model="ruleForm.code"></CInput>
                          <div v-show="visiEmailMessage" style="color:#e55353;font-size:80%;">{{ emailErrorMessage }}</div>
                        </div>
                        <div>
                          <CButton
                            color="success"
                            style="margin-bottom: 1rem;width:100px"
                            block
                            :disabled="dib"
                            @click="reqCode"
                            >{{ cgan == "" ? getVc : cgan }}</CButton
                          >
                        </div>
                    </div>
                    
                  </div>
                  
                </el-tab-pane>
                <el-tab-pane :label="$t('LoginFields.UserAuthenticator')" name="gm">
                  <div style="margin-bottom: 8px">
                    <sup
                      style="
                        color: red;
                        margin-right: 5px;
                        font-size: 14px;
                        vertical-align: bottom;
                      "
                      >*</sup
                    >{{ $t("LoginFields.UserAuthenticator") }}
                  </div>
                  <div style="padding:5px">
                    <CInput style="margin-bottom:5px;" :placeholder="$t('LoginFields.UserGoogleAuthInputPlacholder')" autocomplete="googlecode" v-model="ruleForm.googleCode"></CInput>
                    <div v-show="visiGoogleMessage" style="color:#e55353;font-size:80%;">{{ googleErrorMessage }}</div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
          <div v-else class="step2-box">
            <div>
              <el-alert
                :title="$t('WithdrawUSDT.EnterMissing4AddressCharacters')"
                :closable="false"
                center
              ></el-alert>
            </div>
            <div class="address-container">
              <span class="address-part">{{ addressPrefix }}</span>
              <div class="input-boxes">
                <input
                  v-for="(char, index) in inputChars"
                  :key="index"
                  v-model="inputChars[index]"
                  @input="onInput(index)"
                  @keydown="handleKeyDown($event, index)"
                  ref="charInputs"
                  class="char-input"
                  maxlength="1"
                  type="text"
                />
              </div>
              <span class="address-part">{{ addressSuffix }}</span>
            </div>
          </div>
        </div>
        <div slot="footer">
          <div v-if="step1">
            <el-button size="small" @click="cancelAddAddress">{{
              $t("WithdrawUSDT.Cancel")
            }}</el-button>
            <el-button
              size="small"
              @click="toNext"
              style="background-color: #00bea4; color: #fff"
              >{{ $t("WithdrawUSDT.Next") }}</el-button
            >
          </div>
          <div v-else>
            <el-button
              size="small"
              @click="submitAddAddress"
              style="background-color: #00bea4; color: #fff"
              >{{ $t("WithdrawUSDT.Submit") }}</el-button
            >
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import vueQr from "vue-qr";
import { getAccountSetInfo, unBingWx,updateRecoveryCode,getEmailCode, googleQrCode, googleCode,allUSDTAddress, deleteUSDTAddress,addUSDTAddress, verifyUSDTAddress } from "../../api/http";
import { sendReplaceVerificationCode, verifyReplaceEmailCode, setupUser2fa, confirmUser2fa } from "@/api/cardAuthService";
import AddressTable from '../../components/AddressTable.vue'
import { Loading } from "element-ui";
export default {
  components: {vueQr,AddressTable},
  data() {
    return {
      act_info: "",
      fund_info: "",
      isNone: false,
      value: "0",
      timer: null,
      visiBind: false,
      visiBund: false,
      verifyVisible: false,
      ckVerifyVisible: false,
      code6: null,
      // codeArr: ['12345678','22222222','22212232','52222222','22224222','22221922']
      codeArr: [],
      googleDialogState: false,
      logoScale: 0.2,
      size: 130,
      smCont: true,
      googleCode: null,
      screnCode: 'V7J4Z2D3AQMC57H',
	      erCode: '',
	      loadingGoogle: false,
	      replaceGoogleDialogVisible: false,
	      replaceGoogleStep: 1,
	      replaceEmailCode: '',
	      replaceGoogleCode: '',
	      replaceQrText: '',
	      replaceSecret: '',
	      replaceSetupToken: '',
	      replaceSendingCode: false,
	      replaceVerifyingEmail: false,
	      replaceSettingUp: false,
	      replaceConfirming: false,
	      replaceCodeCountdown: 0,
	      replaceCodeTimer: null,
	      allAddressData: [],
      addressTableLoading: false,
      // add
      dialogAddAddressVisible: false,
      step1: true,
      errorBackAddress: "",
      errorBackTag: "",
      tagFlag: false,
      flags: false,
      // 标准Tron地址示例 (34位)
      fullAddress: "TV6MuMXfmLbBqPZvBHdwFsDnQeVfnmiuSi",
      // 需要用戶輸入的中間字符数量
      hiddenCharsCount: 4,
      // 用户輸入的字符
      inputChars: ["", "", "", ""],
      message: "",
      isSuccess: false,
      // 存储隐藏的字符
      hiddenChars: "",
      addr_id: '',
      masked_addr: '', // 帶有*號字符
      ruleForm: {
        address: "",
        tag: "",
        code: '',
        google_code: '',
        googleCode: ''
      },
      activeNameResetPwd: 'em',
      authType: this.$t('LoginFields.UserEmailRecover'),
      showGoogleCodeInput: false,
      dib: false,
      timer: null,
      timerNum: 60,
      cgan: '',
      tagErrorMessage: '',
      visiTagMessage: false,
      emailErrorMessage: '',
      visiEmailMessage: false,
      googleErrorMessage: '',
      visiGoogleMessage: false
    };
  },
  watch: {
    act_info(val) {
      console.log("act===>", val)
      if(val.wx_oid == "" || val.wx_oid == null) {
        this.visiBind = true
        this.visiBund = false
      }else {
        this.visiBund = true
        this.visiBind = false
      }
    },
    'ruleForm.tag': {
      handler(val) {
        if(val === '') {
          this.visiTagMessage = true
        } else {
          this.visiTagMessage = false
        }
      },
      immediate: true
    },
    'ruleForm.code': {
      handler(val) {
        if(val === '') {
          this.visiEmailMessage = true
        } else {
          this.visiEmailMessage = false
        }
      },
      immediate: true
    },
    'ruleForm.googleCode': {
      handler(val) {
        if(val === '' || val === null) {
          this.visiGoogleMessage = true
        } else {
          this.visiGoogleMessage = false
        }
      },
      immediate: true
    }
  },
  computed: {
    // 地址前綴部分
    addressPrefix() {
      // return this.fullAddress.substring(0, this.hiddenStartIndex);
      return this.extractParts(this.masked_addr).before
    },
    // 地址後綴部分
    addressSuffix() {
      // return this.fullAddress.substring(this.hiddenEndIndex);
      return this.extractParts(this.masked_addr).after
    },
	    getVc: {
	      get() {
	        return this.$t("RegisterFields.SendCode2");
	      },
	      set(v) {
	        console.log("vvv==>", v);
	        this.cgan = v;
	      },
	    },
		    googleRebindText() {
		      return this.$i18n.locale === 'en' ? 'Rebind' : '重新綁定'
		    },
		    accountIsEnglish() {
		      return this.$i18n && this.$i18n.locale === 'en'
		    },
		    replaceGoogleTitle() {
		      return this.accountIsEnglish ? 'Rebind Authenticator' : '重新綁定驗證器'
		    },
		    replaceEmailTip() {
		      return this.accountIsEnglish
		        ? 'Please receive and enter the email verification code before rebinding.'
		        : '重新綁定前，請先接收並輸入郵箱驗證碼。'
		    },
		    replaceEmailCodeLabel() {
		      return this.accountIsEnglish ? 'Email Code' : '郵箱驗證碼'
		    },
		    replaceEmailCodePlaceholder() {
		      return this.accountIsEnglish ? 'Enter email verification code' : '請輸入郵箱驗證碼'
		    },
		    replaceSendCodeText() {
		      if (this.replaceCodeCountdown > 0) {
		        return `${this.replaceCodeCountdown}s`
		      }
		      return this.accountIsEnglish ? 'Send Code' : '發送驗證碼'
		    },
		    replaceNextText() {
		      return this.accountIsEnglish ? 'Next' : '下一步'
		    },
		    replaceGoogleSetupTip() {
		      return this.accountIsEnglish
		        ? 'Scan the QR code with your authenticator app, then enter the 6-digit code to activate.'
		        : '請使用驗證器 App 掃描 QRCode，然後輸入 6 位驗證碼完成激活。'
		    },
		    replaceSecretLabel() {
		      return this.accountIsEnglish ? 'Secret Key' : '密鑰'
		    },
		    replaceGoogleCodeLabel() {
		      return this.accountIsEnglish ? 'Authenticator Code' : '驗證器驗證碼'
		    },
		    replaceGoogleCodePlaceholder() {
		      return this.accountIsEnglish ? 'Enter 6-digit code' : '請輸入 6 位驗證碼'
		    },
		    replaceConfirmText() {
		      return this.accountIsEnglish ? 'Verify and Activate' : '驗證並激活'
		    },
		    replaceCancelText() {
		      return this.accountIsEnglish ? 'Cancel' : '取消'
		    },
	  },
  methods: {
    // 选择验证类型
    handleCommand(e) {
      if(e.name === 'gm') {
        this.authType = this.$t('LoginFields.UserAuthenticator')
        this.showGoogleCodeInput = true

        // this.visiGoogleMessage = true
        // this.visiEmailMessage = false
      }else {
        this.authType = this.$t('LoginFields.UserEmailRecover')
        this.showGoogleCodeInput = false
        
        // this.visiGoogleMessage = false
        // this.visiEmailMessage = true
      }
    },
    // 請求驗證碼
    reqCode() {
      let loading = Loading.service({ fullscreen: true });
      let data = {
        type: "get_email_code",
        code_type: "2fa",
        user_name: window.localStorage.getItem("user_name"),
      };
      let formData = new FormData();
      for (let k in data) {
        formData.append(k, data[k]);
      }
      this.$axios({
        method: "POST",
        url: "/request/user.php",
        // url: process.env.VUE_APP_BASE_URL+"/request/user.php",
        data: formData,
      }).then((code) => {
        if (code.data.code == 200) {
          loading.close();
          this.$message.success(code.data.message);
          this.cellCode();
        } else {
          this.timerNum = 0;
          clearInterval(this.timer);
          this.$message.error(code.data.message);
        }
      });
    },
    // 發送驗證碼
    cellCode() {
      // this.reqCode()
      this.dib = true;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.timerNum--;
        // this.vcode = this.timerNum
        this.getVc = this.timerNum;
        // this.$t('RegisterFields.SendCode2') = this.timerNum
        if (this.timerNum == 0) {
          clearInterval(this.timer);
          // this.vcode = this.rcode
          //  this.vcode = this.$t('RegisterFields.SendCode')
          // this.vcode = this.getVc
          this.timerNum = 60;
          this.dib = false;
        }
      }, 1000);
    },
    openAddAddressDialog() {
      this.dialogAddAddressVisible = true
    },
    closeAddDialog() {
      this.dialogAddAddressVisible = false
      this.step1 = true
      this.ruleForm.address = ''
      this.ruleForm.tag = ''
    },
    // 处理输入事件
    onInput(index) {
      // 确保输入为当前格式（无需强制大写，保持原始格式）
      if (this.inputChars[index].length > 0) {
        // 自动跳到下一个输入框
        if (index < this.hiddenCharsCount - 1) {
          this.$nextTick(() => {
            // console.log('this.$refs', this.$refs.charInputs[index + 1])
            this.$refs.charInputs[index + 1].focus();
          });
        }
      }
    },
    // 处理按键事件
    handleKeyDown(event, index) {
      // 按下退格键时，如果当前输入框为空，则焦点移至前一个输入框
      if (
        event.key === "Backspace" &&
        this.inputChars[index] === "" &&
        index > 0
      ) {
        this.$nextTick(() => {
          this.$refs.charInputs[index - 1].focus();
        });
      }
    },
    // 取消添加地址
    cancelAddAddress() {
      this.ruleForm.address = "";
      this.ruleForm.tag = "";
      this.ruleForm.code = '';
      this.ruleForm.google_code = '';
      this.ruleForm.googleCode = ''
      this.activeNameResetPwd = 'em'
      this.dialogAddAddressVisible = false;

      this.visiGoogleMessage = false
      this.visiEmailMessage = false
      this.visiTagMessage = false
    },
    // 點擊下一步
    toNext() {
      // if(this.ruleForm.address == '' || this.ruleForm.tag == '' || this.flags || this.tagFlag) {
      //   return;
      // }
      if(this.ruleForm.address == '' || this.flags) {
        this.errorBackAddress = this.$t('WithdrawUSDT.Required')
        // return;
      }
      if(this.ruleForm.tag == '') {
        this.visiTagMessage = true
        this.tagErrorMessage = this.$t('WithdrawUSDT.Required')
        // return;
      }
      if(this.activeNameResetPwd == 'em' && this.ruleForm.code == '') {
        console.log('em')
        this.visiEmailMessage = true
        this.emailErrorMessage = this.$t('WithdrawUSDT.Required')
        return;
      }
      if(this.activeNameResetPwd == 'gm' && this.ruleForm.googleCode == '') {
        console.log('gm')
        this.visiGoogleMessage = true
        this.googleErrorMessage = this.$t('WithdrawUSDT.Required')
        return;
      }
      this.visiTagMessage = false
      this.visiEmailMessage = false
      this.visiGoogleMessage = false

      const obj = {
        type: 'add_user_withdraw_address',
        uid: localStorage.getItem("uid"),
        address: this.ruleForm.address,
        tag: this.ruleForm.tag
      }
      const data = this.activeNameResetPwd == 'em' ? { ...obj, email_code: this.ruleForm.code } : { ...obj, google_code: this.ruleForm.googleCode }
      addUSDTAddress(data).then((res) => {
        console.log("add res", res)
        if(res.code == 200) {
          this.addr_id = res.data.addr_id
          this.masked_addr = res.data.masked_addr
          this.step1 = false;
          this.inputChars = this.extractStars(res.data.masked_addr)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 提交添加地址
    submitAddAddress() {
      if(this.inputChars.join('') == '') {
        return;
      }
      const data = {
        type: 'verify_withdraw_address',
        uid: localStorage.getItem("uid"),
        addr_id: this.addr_id,
        verify_char: this.inputChars.join('')
      }
      verifyUSDTAddress(data).then((res) => {
        console.log('sub add res', res)
        if(res.code == 200) {
          // this.wAddr = this.ruleForm.address
          this.initAllAddressApi()
          
          this.cancelAddAddress()
          // this.masked_addr = ''
          // this.addr_id = ''
          
          this.$message.success(res.message)
          // setTimeout(() => {
          //   this.dialogAddAddressVisible = false
          // }, 500)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 驗證標簽
    validatorTag(val) {
      const regex =
        /^[\u4e00-\u9fa5\sA-Za-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/;
      if (val === "") {
        this.errorBackTag = this.$t('WithdrawUSDT.Required');
        this.tagFlag = false;
        return;
      }
      if (regex.test(val)) {
        this.errorBackTag = "";
        this.tagFlag = false;
        return true;
      } else {
        this.errorBackTag = this.$t("VirtualCard.Create.InvalidTag");
        this.tagFlag = true;
        return false;
      }
    },
    validatorAddress(val) {
      // let reg = /^T.*/;
      let reg = /^T[1-9A-HJ-NP-Za-km-z]{33}$/;
      if (val === "") {
        this.errorBackAddress = '';
        this.flags = false;
        return;
      }
      if (reg.test(val)) {
        this.errorBackAddress = "";
        this.flags = false;
        return true;
      } else {
        this.errorBackAddress = this.$t(
          "RewardCenter.BindUSDTAcc.InvalidAddress"
        );
        this.flags = true;
        return false;
      }
    },
    // 提取*號返回數組
    extractStars(str) {
      const stars = str.match(/\*/g) || [];
      return stars.map(() => '');
    },
    // 獲取*號前後字符
    extractParts(str) {
      if(str && str.length === 0) return;
      const starIndex = str.indexOf('*');
      const beforeStars = str.substring(0, starIndex);
      const afterStars = str.substring(starIndex + str.match(/\*/g).length);
      return { before: beforeStars, after: afterStars };
    },
    // 刪除API
    reqDeleteAddressApi(item) {
      const data = {
        type: 'delete_withdraw_address',
        uid: localStorage.getItem("uid"),
        address: item.address
      }
      deleteUSDTAddress(data).then((res) => {
        if(res.code == 200) {
          this.initAllAddressApi();
          this.$message.success(res.message)
        }else {
          this.$message.error(res.message)
        }
      })
    },
    // 點擊刪除對於地址
    clickDeleted(item) {
      let that = this
      this.$alert(
        `<div>
      <div style="margin-bottom:10px;">${this.$t(
        "WithdrawUSDT.ListAddress"
      )}: ${item.address}</div>
      <div>${this.$t("WithdrawUSDT.ListTag")}: ${item.tag}</div>
      </div>`,
        this.$t("WithdrawUSDT.DeleteTip"),
        {
          dangerouslyUseHTMLString: true,
          showCancelButton: true,
          cancelButtonText: this.$t("WithdrawUSDT.Cancel"),
          confirmButtonText: this.$t("WithdrawUSDT.Confirm"),
        }
      )
        .then(() => {
          // console.log("qd");
          that.reqDeleteAddressApi(item)
        })
        .catch(() => {
          console.log("qx");
        });
    },
    // 獲取地址數據
    initAllAddressApi() {
      const data = {
        type: "get_withdraw_address",
        uid: localStorage.getItem("uid"),
      };
      // this.addressTableLoading = true
      allUSDTAddress(data)
        .then((res) => {
          if (res.code == 200) {
            this.allAddressData = res.data || res.data.data;
            this.addressTableLoading = false;
            // this.dialogAddressVisible = true;
            // if(isFromAdd) {
            //   this.filterAddressItem(res.data)
            //   setTimeout(() => {
            //     this.dialogAddAddressVisible = false
            //   }, 500)
            // }
          } else {
            this.$message.error(res.message);
            this.addressTableLoading = false;
          }
        })
        .finally(() => {
          this.addressTableLoading = false
        });
    },
    // 打開驗證身份彈窗
    tqVerify() {
      this.verifyVisible = true
      this.reqGetEmailCode()
    },
	    // 打开Google绑定窗口
	    bindGoogleCode() {
	      this.googleDialogState = true
	      this.createGoogleSecret()
	    },
	    // 打開重新綁定 Google 驗證器窗口，重新綁定流程走新服務接口。
	    openReplaceGoogleDialog() {
	      this.resetReplaceGoogleForm()
	      this.replaceGoogleDialogVisible = true
	    },
	    // 關閉重新綁定窗口時，重置郵箱碼、QRCode、密鑰與驗證器碼。
	    closeReplaceGoogleDialog() {
	      this.resetReplaceGoogleForm()
	    },
	    // 重置重新綁定 Google 驗證器流程的本地狀態。
	    resetReplaceGoogleForm() {
	      this.clearReplaceCodeTimer()
	      this.replaceGoogleStep = 1
	      this.replaceEmailCode = ''
	      this.replaceGoogleCode = ''
	      this.replaceQrText = ''
	      this.replaceSecret = ''
	      this.replaceSetupToken = ''
	      this.replaceSendingCode = false
	      this.replaceVerifyingEmail = false
	      this.replaceSettingUp = false
	      this.replaceConfirming = false
	      this.replaceCodeCountdown = 0
	    },
	    // 清除重新綁定流程的郵箱驗證碼倒計時。
	    clearReplaceCodeTimer() {
	      if (this.replaceCodeTimer) {
	        clearInterval(this.replaceCodeTimer)
	        this.replaceCodeTimer = null
	      }
	    },
	    // 發送郵箱驗證碼成功後，啟動 60 秒倒計時並暫時禁用發送按鈕。
	    startReplaceCodeCountdown() {
	      this.clearReplaceCodeTimer()
	      this.replaceCodeCountdown = 60
	      this.replaceCodeTimer = setInterval(() => {
	        this.replaceCodeCountdown -= 1
	        if (this.replaceCodeCountdown <= 0) {
	          this.replaceCodeCountdown = 0
	          this.clearReplaceCodeTimer()
	        }
	      }, 1000)
	    },
	    // 發送重新綁定前的郵箱驗證碼，不需要傳遞參數。
	    sendReplaceGoogleEmailCode() {
	      if (this.replaceCodeCountdown > 0) return
	      this.replaceSendingCode = true
	      sendReplaceVerificationCode()
	        .then((res) => {
	          if (res.code === 200) {
	            this.startReplaceCodeCountdown()
	            this.$message.success(this.accountIsEnglish ? 'Verification code sent' : '驗證碼已發送')
	          } else {
	            this.$message.error(this.getReplaceGoogleMessage(res))
	          }
	        })
	        .catch((err) => {
	          this.$message.error(err.message || 'Error')
	        })
	        .finally(() => {
	          this.replaceSendingCode = false
	        })
	    },
	    // 驗證郵箱驗證碼是否正確，正確後才請求 QRCode 與 setup_token。
	    verifyReplaceGoogleEmailCode() {
	      const replaceVerificationCode = (this.replaceEmailCode || '').trim()
	      if (!replaceVerificationCode) {
	        this.$message.error(this.replaceEmailCodePlaceholder)
	        return
	      }

	      this.replaceVerifyingEmail = true
	      verifyReplaceEmailCode({ replace_verification_code: replaceVerificationCode })
	        .then((res) => {
	          if (res.code === 200) {
	            this.setupReplaceGoogleAuthenticator()
	          } else {
	            this.$message.error(this.getReplaceGoogleMessage(res))
	          }
	        })
	        .catch((err) => {
	          this.$message.error(err.message || 'Error')
	        })
	        .finally(() => {
	          this.replaceVerifyingEmail = false
	        })
	    },
	    // 郵箱驗證通過後，向新服務取得 QRCode、密鑰與 setup_token。
	    setupReplaceGoogleAuthenticator() {
	      this.replaceSettingUp = true
	      setupUser2fa()
	        .then((res) => {
	          if (res.code === 200) {
	            const setupInfo = this.extractReplaceGoogleSetupInfo(res)
	            this.replaceQrText = setupInfo.qrText
	            this.replaceSecret = setupInfo.secret
	            this.replaceSetupToken = setupInfo.setupToken
	            if (!this.replaceSetupToken) {
	              this.$message.error(this.accountIsEnglish ? 'Setup token is missing' : '缺少 setup_token')
	              return
	            }
	            this.replaceGoogleStep = 2
	          } else {
	            this.$message.error(this.getReplaceGoogleMessage(res))
	          }
	        })
	        .catch((err) => {
	          this.$message.error(err.message || 'Error')
	        })
	        .finally(() => {
	          this.replaceSettingUp = false
	        })
	    },
	    // 驗證使用者輸入的 6 位驗證器碼，成功後完成重新綁定。
	    confirmReplaceGoogleBind() {
	      const code = (this.replaceGoogleCode || '').trim()
	      if (!code) {
	        this.$message.error(this.replaceGoogleCodePlaceholder)
	        return
	      }

	      this.replaceConfirming = true
	      confirmUser2fa({
	        setup_token: this.replaceSetupToken,
	        code
	      })
	        .then((res) => {
	          if (res.code === 200) {
	            localStorage.setItem('google_checking_status', '1')
	            this.$message.success(this.accountIsEnglish ? 'Activated' : '已激活')
	            this.replaceGoogleDialogVisible = false
	          } else {
	            this.$message.error(this.getReplaceGoogleMessage(res))
	          }
	        })
	        .catch((err) => {
	          this.$message.error(err.message || 'Error')
	        })
	        .finally(() => {
	          this.replaceConfirming = false
	        })
	    },
	    // 兼容新服務可能返回的不同 QRCode/密鑰欄位名稱。
	    extractReplaceGoogleSetupInfo(res) {
	      const rawData = res && res.data ? res.data : {}
	      const data = rawData.data || rawData

	      return {
	        qrText: data.otpauth_uri || data.url || data.qr_code || data.qrcode || data.qr || data.otp_auth_url || data.auth_url || data.uri || '',
	        secret: data.secret || data.secret_key || data.key || data.manual_key || '',
	        setupToken: data.setup_token || data.setupToken || data.token || ''
	      }
	    },
	    // 統一解析新服務錯誤訊息，優先依當前語言取 data.en / data.tc。
	    getReplaceGoogleMessage(res) {
	      const langKey = this.accountIsEnglish ? 'en' : 'tc'
	      if (res && res.data && typeof res.data === 'object') {
	        return res.data[langKey] || res.data.en || res.data.tc || res.message || 'Error'
	      }
	      return (res && res.message) || 'Error'
	    },
	    google_checking_status() {
	      let gcs = localStorage.getItem('google_checking_status')
	      if(gcs == '1') {
        return true
      }else {
        return false
      }
    },
    // 点击下一步
    googleBindNext() {
      this.smCont = false
    },
    // 關閉Google的回調
    closeGoogleBind() {
      this.smCont = true
      this.googleCode = null
    },
    // 
    goBack() {
      this.smCont = true
    },
    // 複製
    copyToClipboard(text) {
      navigator.clipboard.writeText(text)
        .then(() => {
          this.$message.success('Copied')
        })
        .catch(err => console.error('複製失敗:', err));
    },
    // 激活Google驗證碼
    completeBindGoogle() {
      if(this.googleCode == null || this.googleCode == '') return;
      this.loadingGoogle = true
      let data = {
        type: '2fa_google_auth',
        google_code: this.googleCode
      }
      googleCode(data).then(res => {
        if(res.code == 200) {
          localStorage.setItem('google_checking_status', '1')
          this.googleDialogState = false
          this.smCont = true
          this.googleCode = null
          this.loadingGoogle = false
          setTimeout(() => {
            this.google_checking_status()
          }, 500)
        }else{
          this.$message.error(res.message)
          this.loadingGoogle = false
        }
      }).catch(e => {
        console.log(e)
        this.loadingGoogle = false
      })
    },
    // 請求二維碼
    createGoogleSecret() {
      let data = {
        type: 'create_google_secret',
        user_name: localStorage.getItem('user_name'),
        uid: localStorage.getItem('uid')
      }
      googleQrCode(data).then(res => {
        if(res.code == 200) {
          this.screnCode = res.data.secret
          this.erCode = res.data.url
        }else{
          this.$message.error(res.message)
        }
      })
    },
    // 繼續
    jxHandler() {
      
      if(this.code6 == null) {
        return
      }else {
        this.reqUpdateRecoveryCode()
        // this.ckVerifyVisible = true
          // this.verifyVisible = false
      }
    },
    // 關閉
    gbHandler() {
      this.ckVerifyVisible = false
      this.code6 = null
    },
    // 請求獲取驗證碼
    reqGetEmailCode() {
      let data = {
        type: 'get_email_code',
        code_type: '2fa',
        user_name: localStorage.getItem('user_name')
      }
      getEmailCode(data).then((res) => {
        if(res.code == 200) {
          
          this.$message.success(res.message)
        }else {
          this.$message.error(res.message)
        }
      })
    },
    // 請求更新備用碼
    reqUpdateRecoveryCode() {
      let data = {
        type: 'update_recovery_code',
        uid: localStorage.getItem('uid'),
        email_code: this.code6
      }
      updateRecoveryCode(data).then((res) => {
        if(res.code == 200) {
          this.ckVerifyVisible = true
          this.verifyVisible = false
          this.codeArr = res.data
        }else {
          this.$message.error(res.message)
        }
      })
    },
    getStatus(status) {
      return status === "Verifying"
        ? "#4CA1E5"
        : status === "Complete"
        ? "#00BEA4"
        : "#F56C6C";
    },
    copyData(data) {
      // let variable = data.map(item => {return `${item}\r\n`})
      let variable = ``
      data.map((item, index) => {
        // for(let key in item) {
        //   variable += `${item}\t`
        // }
        variable += `${item}`
        // variable += '\n'
      })
      var tag = document.createElement('textarea')
      document.body.appendChild(tag)
      tag.value = variable
      tag.select()
      document.execCommand('copy', false)
      tag.remove()
    },
    // 格式複製方法
    selectElementContents(el) {
      var body = document.body,
          range,
          sel;
          console.log('sel==>', sel)
          console.log('range==>', range)
      if(document.createRange && window.getSelection) {
        range = document.createRange()
        sel = window.getSelection()
        sel.removeAllRanges()
        try {
          range.selectNodeContents(el)
          sel.addRange(range)
          console.log('range==>', range)
        } catch(e) {
          range.selectNode(el)
          sel.addRange(range)
        }
        document.execCommand("copy")
        // 取消文本選中狀態
        window.getSelection().empty()
        this.$message.success("Copied")
      }    
    },
    // 點擊複製
    clickCopy() {
      this.selectElementContents(document.getElementById("colContent"))
      // this.copyData(this.codeArr)
    },
    toResetpwd() {
        this.$router.push("/users/resetpassword")
    },
    toAddFund() {
        this.$router.push("/funds/accounts")
    },
    toWechatBind() {
      this.$router.push("/users/wechat-bind")
    },
    switchVal() {
        let obj = {
            type: "update_2fa_login",
            uid: window.localStorage.getItem("uid"),
            switch: this.value
        }
        let formData = new FormData();
        for (let k in obj) {
            formData.append(k, obj[k]);
        }
        this.$axios({
        method: "POST",
        url: "/request/user.php",
        // url: process.env.VUE_APP_BASE_URL+"/request/user.php",
        data: formData,
      }).then((code) => {
        if (code.data.code == 200) {
          this.getData()
        } else {
          this.$message.error(code.data.message);
        }
      });
    },
    // 请求解除绑定接口
    reqUnBindWx() {
      let obj = {
        type: "unbind_wx",
        uid: localStorage.getItem('uid') 
      }
      unBingWx(obj).then((res) => {
        if(res.code == 200) {
          this.$message.success(res.message)
          this.getData()
        }else {
          this.$message.error(res.message)
        }
      })
    },
    // 解除微信绑定
    unBind() {
      let that = this
      this.$confirm(this.$t('avatarSelect.TipMessage'), '', {
          confirmButtonText: that.$t('avatarSelect.Confirm'),
          cancelButtonText: that.$t('avatarSelect.Cancel'),
          showClose: false,
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          that.reqUnBindWx()
        }).catch(() => {
                   
        });
    },
    getData() {
      let data = {
        type: "get_account_setting_info",
        uid: window.localStorage.getItem("uid"),
      };
      getAccountSetInfo(data).then((res) => {
        if (res.code == 200) {
          this.act_info = res.data.account_info[0];
          this.value = res.data.account_info[0].login_2fa
          if (res.data.fund_account.length == 0) {
            this.isNone = true;
          } else {
            this.isNone = false;
            this.fund_info = res.data.fund_account[0];
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
	  created() {
	    this.getData();
	    this.initAllAddressApi()
	    console.log('state', this.$store)
	  },
	  beforeDestroy() {
	    this.clearReplaceCodeTimer()
	  },
	};
</script>


<style scoped>
/* add dialog */
.address-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 30px 0;
  font-size: 14px;
  /* flex-wrap: wrap; */
}
.fl {
  display: flex;
  gap: 10px;
}
.address-part {
  color: #333;
  word-break: break-all;
  font-family: monospace;
}
.input-boxes {
  display: flex;
  gap: 5px;
  margin: 0 5px;
}
.char-input {
  width: 32px;
  height: 32px;
  text-align: center;
  font-size: 20px;
  border: 2px solid #e8e8e8;
  border-radius: 4px;
  outline: none;
  font-family: monospace;
}
.char-input:focus {
  /* border-color: #ff0000; */
  /* box-shadow: 0 0 5px rgba(255, 0, 0, 0.3); */
  color: #768192;
  background-color: #fff;
  border-color: #958bef;
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.25);
  box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.25);
}
.verification-button {
  display: block;
  width: 100%;
  padding: 12px;
  background-color: #ff3333;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 20px;
}
.verification-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}
.message {
  margin-top: 15px;
  text-align: center;
  font-weight: bold;
}
.success {
  color: #2ecc71;
}
.error {
  color: #e74c3c;
}
.address-info {
  text-align: center;
  margin-top: 10px;
  font-size: 14px;
  color: #666;
}
@media (max-width: 480px) {
  .address-container {
    flex-direction: column;
    gap: 10px;
  }
  .address-part,
  .input-boxes {
    font-size: 16px;
  }
  .char-input {
    width: 35px;
    height: 35px;
    font-size: 16px;
  }
}
/* end */
.box-item{
  width: 100%;
  display: flex;
  background: #F5F6F7;
  padding: 1rem 0;
  color: #42474d;
  font-size: 14px;
  font-family: AxLLCircular, Helvetica, Arialsans-serif;
}
.sent-tip{
  padding: 20px 0;
}
.digTitle{
  font-size: 22px;
  font-weight: bold;
}
.jx-btn{
  outline: 0;
}
.jx-btn:hover{
    background: #E6F9F6;
    color: #00BEA4;
    border-color: #00BEA4;
}
.jx-btn:focus{
    background: #E6F9F6;
    color: #00BEA4;
    border-color: #00BEA4;
    outline: 0;
}
.title-ck-box{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.title-ck-tip{
  font-size: 14px;
  padding: 20px 0;
  border-bottom: 1px solid #eee;
}
.grid-content{
  padding-bottom: 10px;
  font-weight: bold;
  font-family: Microsoft Yahei;
  letter-spacing: 2px;
}
.bound{
  margin-left: 0 !important;
  color: #424c4d;
  font-weight: normal;
}
.sbtn:hover{
  background: rgba(0,190,164, .8) !important;
}
.sbtn:focus{
  border-color: #00BEA4;
  box-shadow: 0 0 0 .25rem rgba(0,190,164, .5) !important;
}
.custer{
  background: #00bea4;
  color: #fff; 
  width: 100%;
  outline:0;
}
/*  */
.cur{
  outline: none;
  border: none;
  color: #00BEA4;
  background: transparent;
  padding: 6px 12px;
  font-weight: bold;
}
.hv:hover{
  background: rgb(0,190,164);
  color: #fff;
  border-radius: 0.375rem;
}
.google-rebind-btn {
  display: block;
  margin: 4px 0 0 auto;
  padding: 0;
  border: none;
  outline: none;
  background: transparent;
  color: #00BEA4;
  font-size: 12px;
  line-height: 18px;
  cursor: pointer;
}
.google-rebind-btn:hover {
  text-decoration: underline;
}
.replace-google-step {
  min-height: 160px;
}
.replace-google-field {
  margin-top: 18px;
}
.replace-google-label {
  display: block;
  margin-bottom: 8px;
  color: #303133;
  font-size: 14px;
  font-weight: 600;
}
.replace-email-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
.replace-email-row >>> .form-group {
  flex: 1;
  margin-bottom: 0;
}
.replace-email-row >>> .form-control {
  height: 40px;
}
.replace-google-primary-btn {
  min-width: 84px;
  height: 40px;
  padding: 0 16px !important;
  background: #00BEA4 !important;
  border-color: #00BEA4 !important;
  color: #ffffff !important;
}
.replace-google-primary-btn.is-disabled,
.replace-google-primary-btn.is-disabled:hover,
.replace-google-primary-btn.is-disabled:focus {
  background: #8ddfd3 !important;
  border-color: #8ddfd3 !important;
  color: #ffffff !important;
}
.replace-google-primary-btn:hover,
.replace-google-primary-btn:focus {
  background: #00a892 !important;
  border-color: #00a892 !important;
  color: #ffffff !important;
}
.replace-google-qr-row {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 12px;
}
.replace-google-secret {
  min-width: 0;
  flex: 1;
}
.replace-google-secret-value {
  color: #00BEA4;
  font-weight: 700;
  word-break: break-all;
}
.replace-google-secret-value i {
  margin-left: 6px;
  font-size: 18px;
  cursor: pointer;
}
.account-box {
  height: 100%;
  background: #fff;
  padding-left: 2.6rem;
}
.cr-box {
  width: 83%;
  margin: 0 auto;
  overflow: hidden;
  padding-top: 2rem;
}
.item-t {
  /* color: #3c2b2b; */
  /* font-weight: bold; */
  padding-bottom: 1.25rem;
  color: #42474d;
  font-size: 14px;
  font-family: AxLLCircular, Helvetica, Arialsans-serif;

}
.item-v {
  color: #a196aa;
  font-size: 14px;
  font-weight: bold;
  padding-bottom: 1.25rem;
}
.scry-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 0;
  border-bottom: 1px solid #ebeef5;
  color: #42474d;
  font-size: 14px;
  font-family: AxLLCircular, Helvetica, Arialsans-serif;
}
.acitem{
    width: 100%;
    height: 33px;
    line-height: 33px;
    background: #F5F6F7;
    padding-left: 1rem;
    padding-right: 1rem;
}
.card-title{
    font-weight: bold;
    font-size: 1.1rem;
}
.et{
    padding: 0.3rem 0.5rem;
    background: #DFF6E6;
    margin-left: 0.5rem;
    border-radius: 5px;
}
.nitem{
  display: flex;
  align-items: center;
  height: 33px;
  line-height: 33px;
}
</style>
